<template>
  <v-card flat>
    <FormField label="Nome da Forma de Entrega" v-model="form.nomeForma" />
    <FormField label="Código ERP" v-model="form.idFormaEntregaErp" />
    <FormFile
      v-if="form.id == 'novo'"
      label="Arquivo"
      v-model="form.nameCurrentFile"
      @file="onSelectFile"
    >
      <template v-slot:help>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ml-3">far fa-question-circle</v-icon>
          </template>
          Localize o arquivo de frete editado a partir do modelo disponível para
          importação
        </v-tooltip>
      </template>
    </FormFile>
    <FormSwitch
      v-model="form.permiteAgendamento"
      label="Permite agendamento"
      @click="form.idCalendarioEntrega = null"
    />
    <FormSelect
      v-if="form.permiteAgendamento"
      label="Calendário"
      :options="calendarios"
      v-model="form.idCalendarioEntrega"
    />
    <h4 v-if="form.id == 'novo'">Enconding Arquivo</h4>
    <v-row no-gutters v-if="form.id == 'novo'">
      <v-col>
        <FormRadioGroup v-model="form.encoding" inline :radios="encondings" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FormField from "@/components/form/FormField";
import FormFile from "@/components/form/FormFile";
import FormSwitch from "@/components/form/FormSwitch";
import FormSelect from "@/components/form/FormSelect";
import FormRadioGroup from "@/components/form/FormRadioGroup";
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";

export default {
  name: "FormaEntregaFormTransporte",
  components: {
    FormField,
    FormFile,
    FormSwitch,
    FormSelect,
    FormRadioGroup
  },
  props: {
    calendarios: {
      type: [Array],
      default: () => ({}),
      required: true
    },
    data: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
      form: {},
      encondings: [
        { label: "UTF-8", value: "utf8" },
        { label: "ISO-8859-1", value: "binary" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getFornecedorTag"])
  },
  methods: {
    update() {
      this.$emit("update", this.form);
    },
    onSelectFile(file) {
      const size = 100 * 1024 * 1024;
      const allowedExtensions = ["csv"];
      if (file.size > size) {
        this.$vueOnToast.pop(
          "info",
          "Arquivo muito grande, pode levar alguns minutos para processar!"
        );
      }

      const fileExtension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$vueOnToast.pop(
          "error",
          "Formato de arquivo inválido! Apenas CSV é permitido."
        );
        this.form.nameCurrentFile = null;
        return;
      }

      this.form.currentFile = file;

      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        this.form.detalhesCustoTransporte = this.converterDados(jsonData);
      };

      reader.readAsArrayBuffer(file);

      this.update();
    },
    converterDados(dados) {
      const chaves = dados[1].map(this.snakeToCamel);
      const objetos = dados.slice(2).map(linha => {
        return chaves.reduce((obj, chave, index) => {
          obj[chave] = linha[index];
          return obj;
        }, {});
      });

      return objetos;
    },
    snakeToCamel(str) {
      return str.replace(/_([a-z])/g, (_, letra) => letra.toUpperCase());
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("update", this.form);
      }
    }
  },
  created() {
    this.form = this.data;
  }
};
</script>
